import * as React from 'react'

function SvgIconEmailDraft(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="email-draft" aria-labelledby="t-email-draft d-email-draft">
        <title id="t-email-draft">{'Draft email'}</title>
        <desc id="d-email-draft">
          {'An open envelope revealing an empty paper sheet'}
        </desc>
        <path d="M31.6 12.2L27 8.5V4h-5.6L16.7.2c-.3-.1-.5-.2-.7-.2s-.4.1-.6.2L10.6 4H5v4.5L.4 12.2c-.3.2-.4.5-.4.8v18c0 .6.4 1 1 1h30c.6 0 1-.4 1-1V13c0-.3-.1-.6-.4-.8zM16 1l3.8 3h-7.5L16 1zM6 5h20v12l-10 8-10-8V5zM5 9.8v6.4L1 13l4-3.2zM31 31H1V14.3l14.4 11.5c.2.1.4.2.6.2s.4-.1.6-.2L31 14.3V31zm-4-14.8V9.8l4 3.2-4 3.2z" />
        <path d="M29.6 14c.301 0 .5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5zm-2 0c.301 0 .5-.2.5-.5s-.2-.5-.5-.5-.5.2-.5.5.2.5.5.5zM4.4 13c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.3-.5-.5-.5zm-2 0c-.3 0-.5.2-.5.5s.2.5.5.5.5-.2.5-.5-.2-.5-.5-.5z" />
      </g>
    </svg>
  )
}

export default SvgIconEmailDraft
